import apiClient from "@/axios";

export const getNotifications = async () => {
  const response = await apiClient.post("/user/notifications/get-all");
  return response;
};

export const markReadAllNotifications = async () => {
  const response = await apiClient.post("/user/notifications/mark-all-as-read");
  return response;
};

export const markNotificationAsRead = async (id) => {
  const response = await apiClient.post("/user/notifications/mark-as-read", {
    id: id,
  });
  return response;
};

export const deleteAllNotifications = async () => {
  const response = await apiClient.post("/user/notifications/delete-all");
  return response;
};

export const deleteNotification = async (id) => {
  const response = await apiClient.post("/user/notifications/delete", {
    id: id,
  });
  return response;
};
